import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, NG_VALIDATORS, Validator} from "@angular/forms";
import {TranslocoService} from "@ngneat/transloco";
import {AbstractComponent} from "../abstract.component";
import {Lookups} from "@model";
import {CodebookService} from "@services";
import {required} from '@utility';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-language-input',
  templateUrl: './language-input.component.html',
  styleUrls: ['./language-input.component.scss'],
  providers:
    [{
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: LanguageInputComponent
    }]
})
export class LanguageInputComponent extends AbstractComponent implements OnInit, OnChanges {
  @Input() inputForm?: FormGroup<any>;
  @Input() defaultLanguage?: number | undefined;
  @Input() extraLanguages?: number[] | undefined;
  @Input() required: boolean = true;
  @Input() hrKey?: string;
  @Input() enKey?: string;
  @Input() siKey?: string;
  @Input() itKey?: string;
  @Input() hrLabel?: string;
  @Input() enLabel?: string;
  @Input() siLabel?: string;
  @Input() itLabel?: string;
  @Input() isInput: boolean = true;
  selectedLanguage: string = "hr";
  languages: Lookups[] = [];
  defaultLanguageCode: string = "hr";


  constructor(public translocoService: TranslocoService, private codebookService: CodebookService, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.initCodebookService();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultLanguage']?.currentValue !== changes['defaultLanguage']?.previousValue) {
      this.setRequiredMultiLanguageFields();
    }
    if (JSON.stringify(changes['extraLanguages']?.currentValue) !== JSON.stringify(changes['extraLanguages']?.previousValue)) {
      this.setRequiredMultiLanguageFields();
    }
    if (changes['inputForm']?.currentValue !== changes['inputForm']?.previousValue) {
      this.setRequiredMultiLanguageFields();
    }
  }

  private initCodebookService() {
    this.subscribeToCodebookServiceValues()
  }

  private subscribeToCodebookServiceValues(): void {
    // todo - check if getting from route data is possible
    this.subscriptions.push(this.codebookService.languages.value.subscribe((value: Lookups[] | null) => {
      if (value !== null) {
        this.languages = value;
        this.setRequiredMultiLanguageFields();
      }
    }));
  }


  private setRequiredMultiLanguageFields() {
    let defaultLang;
    if (this.defaultLanguage) {
      defaultLang = this.languages.filter((language: Lookups) => language?.id === this.defaultLanguage)[0];
    } else {
      defaultLang = this.languages.filter((language: Lookups) => language?.code === this.translocoService.getActiveLang())[0];
    }
    this.selectedLanguage = defaultLang?.code ?? "hr";
    this.defaultLanguageCode = defaultLang?.code ?? "hr";

    if (this.required) {
      let requiredFields: FormControl[] = this.getRequiredLanguageNameFields(defaultLang?.code)
      let nonRequiredFields: FormControl[] = this.getNonRequiredLanguageNameFields(defaultLang?.code)
      requiredFields.forEach((control: FormControl) => {
        control.addValidators([required]);
        control.updateValueAndValidity();
      });
      nonRequiredFields.forEach((control: FormControl) => {
        control.removeValidators([required]);
        control.updateValueAndValidity();
      });
      if (this.extraLanguages) {
        this.extraLanguages.forEach((extraLanguageId: number) => {
          let extraLanguage = this.languages.filter((language: Lookups) => language?.id === extraLanguageId!)[0];
          this.getRequiredLanguageNameFields(extraLanguage?.code).forEach((control: FormControl) => {
            control.addValidators([required]);
            control.updateValueAndValidity();
          });
        });
      }
    }
  }

  private getRequiredLanguageNameFields(lang: string | undefined): FormControl[] {
    switch (lang) {
      case "hr":
        // @ts-ignore
        return [this.inputForm!.controls[this.hrKey!]];

      case "en":
        // @ts-ignore
        return [this.inputForm!.controls[this.enKey!]];

      case "it":
        // @ts-ignore
        return [this.inputForm!.controls[this.itKey!]];

      case "slo":
        // @ts-ignore
        return [this.inputForm!.controls[this.siKey!]];

      default:
        return [];
    }
  }

  private getNonRequiredLanguageNameFields(lang: string | undefined): FormControl[] {
    switch (lang) {
      case "hr":
        return [
          // @ts-ignore
          this.inputForm!.controls[this.enKey!],
          // @ts-ignore
          this.inputForm!.controls[this.itKey!],
          // @ts-ignore
          this.inputForm!.controls[this.siKey!]];
      case "en":
        return [
          // @ts-ignore
          this.inputForm!.controls[this.hrKey!],
          // @ts-ignore
          this.inputForm!.controls[this.itKey!],
          // @ts-ignore
          this.inputForm!.controls[this.siKey!]];
      case "it":
        return [
          // @ts-ignore
          this.inputForm!.controls[this.hrKey!],
          // @ts-ignore
          this.inputForm!.controls[this.enKey!],
          // @ts-ignore
          this.inputForm!.controls[this.siKey!]];
      case "slo":
        return [
          // @ts-ignore
          this.inputForm!.controls[this.hrKey!],
          // @ts-ignore
          this.inputForm!.controls[this.itKey!],
          // @ts-ignore
          this.inputForm!.controls[this.enKey!]];
      default:
        return []
    }
  }

  setLanguage(lang: string): void {
    this.selectedLanguage = lang;
  }

}
